import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/org')({
  beforeLoad: ({ context }) => {
    // Admin access is checked per-org now. Super-admins always pass; otherwise
    // the user must hold at least `admin` within their currently active org.
    if (!context.auth.hasOrgRole('admin')) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: () => <Outlet />,
})
